import { ShabitName } from '@smu-chile/pkg-unimarc-components'

export const myProfileBannerAssetIdByShabitName: Record<ShabitName, string> = {
  bronze: process.env.NEXT_PUBLIC_PROBILE_BANNER_BRONZE,
  silver: process.env.NEXT_PUBLIC_PROBILE_BANNER_SILVER,
  gold: process.env.NEXT_PUBLIC_PROBILE_BANNER_GOLD,
  vip: process.env.NEXT_PUBLIC_PROBILE_BANNER_VIP
}
